exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ExerciseWrapper-module__wrapper___1CsKh{z-index:1;padding:0 1.5em;max-width:calc(100vw - 200px);position:relative;top:25px}", ""]);

// exports
exports.locals = {
	"wrapper": "ExerciseWrapper-module__wrapper___1CsKh"
};